import { render, staticRenderFns } from "./Contract.yaml?vue&type=template&id=15511cc8&component"
import script from "./Contract.yaml?vue&type=script&lang=ts&component"
export * from "./Contract.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports